module.exports = __webpack_public_path__ + "media/images/gateway/8-c15b9034ed7d36c7feac38cd091731ab.png";